import {
  FinanceInfoDetailedFields,
  FinanceInfoVisibleFields,
  GeneralLoanInfoDetailedFields,
  GeneralLoanInfoVisibleFields,
  ProductInfoDetailedFields,
  ProductInfoVisibleFields,
  SubjectPropertyDetailedFields,
  SubjectPropertyVisibleFields
} from "./fields";
import { SchemaVersionEnum } from "./schema";
import { filterFieldsNotIncludedInDefaultSchema } from "../services/schemaTools";
import { defaultSchemaRuleArray } from "./defaultRules";
const LATEST_SCHEMA_VERSION = SchemaVersionEnum.V17;
const SimpleSearchSchema = {
  version: LATEST_SCHEMA_VERSION,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: [{ id: "d21ae94c-d562-4221-9b79-feb86eb27214" }]
      },
      {
        id: "d21ae94c-d562-4221-9b79-feb86eb27214",
        type: "screen",
        name: "Simple Search",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: [
              {
                label: "Lock Period",
                component_id: "Lock Period",
                id: "5fbc3d59-24fa-45bf-898a-e340eced1c07",
                required: true,
                type: "enum",
                ui: { col_size: 2, widget: "dropdown" },
                visible: true,
                selectMultiple: false,
                encompass_ids: [
                  {
                    id: "lockDays",
                    description: "Lock Period",
                    modelPath: "lockDays"
                  }
                ],
                options: []
              },
              {
                label: "Loan Terms",
                component_id: "Loan Terms",
                helptext: "Select one or more loan terms",
                id: "cb3f524e-8051-4a14-a0a2-e488c07ced41",
                required: false,
                type: "enum",
                ui: { col_size: 2, widget: "dropdown" },
                visible: true,
                selectMultiple: true,
                encompass_ids: [
                  {
                    id: "productType",
                    description: "Loan Terms",
                    modelPath: "productType"
                  }
                ],
                options: []
              },
              {
                label: "Standard Products",
                component_id: "Standard Products",
                helptext: "Select one or more standard products",
                id: "fa98ef18-bf10-40b2-8334-ca4627e718f5",
                required: false,
                type: "enum",
                ui: { col_size: 3, widget: "dropdown" },
                visible: true,
                selectMultiple: true,
                encompass_ids: [
                  {
                    id: "standardProducts",
                    description: "Standard Products",
                    modelPath: "standardProducts"
                  }
                ],
                options: []
              },
              {
                label: "Special Products",
                component_id: "Special Products",
                id: "3a5f2d3f-91b9-4d34-9bdc-ee80081a66fa",
                required: false,
                type: "enum",
                ui: { col_size: 3, widget: "dropdown" },
                visible: true,
                selectMultiple: true,
                encompass_ids: [
                  {
                    id: "specialProducts",
                    description: "Special Products",
                    modelPath: "specialProducts"
                  }
                ],
                options: []
              },
              {
                label: "Product Options",
                component_id: "Product Options",
                id: "7c327485-f6dd-4aa5-a9fe-a4b85790cf4f",
                required: false,
                type: "enum",
                ui: { col_size: 2, widget: "dropdown" },
                visible: true,
                selectMultiple: true,
                encompass_ids: [
                  {
                    id: "productOptions",
                    description: "Product Options",
                    modelPath: "productOptions"
                  }
                ],
                options: []
              },
              {
                label: "Income",
                component_id: "Income",
                id: "9552759a-2a01-4057-9e3f-58461349d1ff",
                required: false,
                type: "enum",
                ui: { col_size: 2, widget: "dropdown" },
                visible: false,
                visible_check: {
                  handler: "67e581c4-96c4-4901-8bd5-c7a2c3ecdd0c"
                },
                encompass_ids: [
                  {
                    id: "income",
                    description: "Income",
                    modelPath: "borrowerFinancialHistory.docTypeIncome"
                  }
                ],
                options: [
                  {
                    id: "Full Income",
                    value: "100",
                    text: "Full Income",
                    visible: true
                  },
                  {
                    id: "Alternative Income",
                    value: "70",
                    text: "Alternative Income",
                    visible: true
                  },
                  {
                    id: "Lite Income",
                    value: "60",
                    text: "Lite Income",
                    visible: true
                  },
                  {
                    id: "Stated Income",
                    value: "50",
                    text: "Stated Income",
                    visible: true
                  },
                  {
                    id: "No Income",
                    value: "0",
                    text: "No Income",
                    visible: true
                  }
                ]
              },
              {
                label: "Non-QM Doc Level",
                component_id: "Non-QM Doc Level",
                id: "9c7bab92-2ec9-420a-9de2-d7ab576013ba",
                required: false,
                type: "enum",
                ui: { col_size: 3, widget: "dropdown" },
                visible: false,
                visible_check: {
                  handler: "01fd7f37-f673-4de8-85fc-25de2d0855fc"
                },
                encompass_ids: [
                  {
                    id: "borrowerFinancialHistory.nonQMDocLevel",
                    description: "Non-QM Doc Level",
                    modelPath: "borrowerFinancialHistory.nonQMDocLevel"
                  }
                ],
                options: []
              },
              {
                label: "DSCR",
                component_id: "DSCR",
                id: "d29d8fe1-74f3-4896-94a9-0a965427e9af",
                required: false,
                type: "number",
                ui: {
                  col_size: 2
                },
                visible: false,
                disabled: false,
                encompass_ids: [
                  {
                    id: "borrowerFinancialHistory.dscr",
                    description: "DSCR",
                    modelPath: "borrowerFinancialHistory.dscr"
                  }
                ],
                visible_check: {
                  handler: "829c15f3-68f2-4161-b44a-7361ec9d02bc"
                }
              }
            ]
          }
        ]
      }
    ]
  },
  schemaRules: defaultSchemaRuleArray
};
const EmptySchema = {
  version: LATEST_SCHEMA_VERSION,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: []
      }
    ]
  },
  schemaRules: []
};
const NSSampleSchema = {
  version: LATEST_SCHEMA_VERSION,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: [
          {
            // Refers to screens below
            id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2"
          },
          {
            id: "56cac222-e97d-4993-81c7-a0d86a92244a"
          },
          {
            id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0"
          },
          {
            id: "66cb28eb-7754-499e-bc0c-c399728f9598"
          }
        ]
      },
      {
        id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2",
        type: "screen",
        name: "General Loan Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: GeneralLoanInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: GeneralLoanInfoDetailedFields
          }
        ]
      },
      {
        id: "56cac222-e97d-4993-81c7-a0d86a92244a",
        type: "screen",
        name: "Product Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: filterFieldsNotIncludedInDefaultSchema(
              ProductInfoVisibleFields
            )
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: ProductInfoDetailedFields
          }
        ]
      },
      {
        id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0",
        type: "screen",
        name: "Finance Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: FinanceInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: FinanceInfoDetailedFields
          }
        ]
      },
      {
        id: "66cb28eb-7754-499e-bc0c-c399728f9598",
        type: "screen",
        name: "Subject Property Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: SubjectPropertyVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: SubjectPropertyDetailedFields
          }
        ]
      }
    ]
  },
  schemaRules: defaultSchemaRuleArray
};
const SamplePricingSearchConfigurationStore = [
  {
    channel: "Brokered",
    draftSchema: NSSampleSchema,
    modifiedOn: (/* @__PURE__ */ new Date()).getTime().toString(),
    publishedSchema: null,
    userLastEdited: "Dave"
  }
];
export {
  EmptySchema,
  LATEST_SCHEMA_VERSION,
  NSSampleSchema,
  SamplePricingSearchConfigurationStore,
  SimpleSearchSchema
};
